import {AfterContentInit, Component, ContentChildren, EventEmitter, Input, Output, QueryList, TemplateRef, ViewChild} from '@angular/core';
import {MatStepper} from '@angular/material';
import {StepperReadyEvent} from '../../events/stepper-ready.event';
import {StepTemplateDirective} from '../../directives/step-template.directive';
import {StepComponent} from '../../step/step.component';
import {StepperConfig} from '../../stepper.config';
import {StepperService} from '../../stepper.service';
import {Step} from '../../step/step';
import {ExecutionService} from '../../execution/execution.service';

@Component({
    selector: 'mydocma-stepper',
    templateUrl: './mydocma-stepper.component.html',
    styleUrls: ['./mydocma-stepper.component.scss'],
    providers: [
        ExecutionService,
        StepperService
    ]
})
export class MydocmaStepperComponent implements AfterContentInit {

    @ContentChildren(StepTemplateDirective)
    public typeTemplates: QueryList<StepTemplateDirective>;

    @ViewChild(MatStepper, {static: true})
    public stepper: MatStepper;

    @Input()
    public stepperConfig: StepperConfig;

    @Output()
    public ready = new EventEmitter<StepperReadyEvent>();

    constructor(
        public readonly stepperService: StepperService,
        public readonly executionService: ExecutionService
    ) {
    }

    public ngAfterContentInit(): void {
        const typeTemplatesMap: Map<string, TemplateRef<StepComponent>> = new Map();
        this.typeTemplates.forEach(typeTemplate => {
            typeTemplatesMap.set(typeTemplate.mydocmaStep, typeTemplate.template);
        });

        this.stepperService.init(this.stepperConfig, this.stepper, typeTemplatesMap);

        this.ready.emit({
            stepperService: this.stepperService,
            executionService: this.executionService
        });

        setTimeout(() => {
            this.stepperService.getStepByIndex(0).component.enter();
        });
    }

    public async onStepClicked(event, step: Step) {
        event.stopPropagation();

        const currentStepIndex = this.stepperService.currStep.index;
        const nextStepIndex = this.stepperService.getStepByName(step.config.name).index;

        if (nextStepIndex > currentStepIndex) {
            await this.stepperService.nextStep(step.config.name);

            return;
        }

        await this.stepperService.prevStep(step.config.name);
    }
}
